import React from 'react';
import PropTypes from 'prop-types';

import { NEWSLETTER_SIGNUP } from 'mocks/mutations';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import withApolloClient from 'components/hoc/withApolloClient';

const initCaps = name => {
  const array = name ? name.split(' ') : '';
  const newArray = [];
  for (let i = 0; i < array.length; i++) {
    newArray.push(array[i].charAt(0).toUpperCase() + array[i].slice(1));
  }
  return newArray.join(' ');
};

const getFullName = email => {
  const name = email ? email.split('@')[0].replace(/[^A-Z0-9]/gi, ' ') : '';
  return initCaps(name);
};

class CouponsSubscribeForm extends React.Component {
  state = {
    email: '',
    error: null,
    loading: null,
    success: false,
  };

  onEmailChange = evt =>
    this.setState({ error: null, email: evt.target.value });

  submitEmail = async evt => {
    evt.preventDefault();

    const { email } = this.state;

    if (!email) {
      return this.setState({ error: 'Please enter your email address' });
    }

    try {
      this.setState({ error: null, success: false, loading: true });
      const res = await this.props.client.mutate({
        mutation: NEWSLETTER_SIGNUP,
        variables: {
          email,
          source: 'VIP list',
          full_name: getFullName(email),
        },
      });
      if (res.data.newsletterSignUp) {
        this.setState({
          email: '',
          success: true,
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
          error: 'Unable to sign up for coupons',
        });
      }
    } catch (e) {
      this.setState({
        loading: false,
        error: 'Unable to sign up for coupons',
      });
    }

    return false;
  };

  render() {
    if (this.state.success) {
      return (
        <div className="px-7 py-[3.25rem] text-center mb-8">
          <h4 className="text-gray font-bold text-[1.75rem]">
            Success! You’re ready to start saving.
          </h4>
          <div className="text-[#74777a] font-bold mt-2">
            Watch your email for new codes and promotions.
          </div>
        </div>
      );
    }

    return (
      <div className="mt-12 mx-auto mb-24 flex text-center items-center flex-col">
        <div className="coupons-subscribe__panel">
          <h4 className="text-gray font-bold text-4xl">Don&apos;t miss out!</h4>
          <div className="text-[#74777a] mt-4 mx-0 mb-8">
            <p>Join our V.I.P. list and receive the latest coupons,</p>
            <p>promotions, product launches and secret sales.</p>
          </div>
          <form
            onSubmit={this.submitEmail}
            className="w-[35rem] mt-4 max-[600px]:w-80"
          >
            <div className="h-[4.25rem] m-0">
              <LabeledTextInput
                data-xc="coupons-subscribe-email"
                id="email"
                name="email"
                type="email"
                label="Email"
                autoCorrect="off"
                autoCapitalize="off"
                value={this.state.email}
                onChange={this.onEmailChange}
              />
            </div>
            {this.state.error && <div className="mb-3">{this.state.error}</div>}
            <div>
              <CtaButton
                type="submit"
                color="black"
                noLinkPadding
                hasArrow={false}
                styling="solid-button"
                disabled={this.state.loading}
                data-xc="coupons-subscribe-submit"
                isLoading={this.state.loading}
              >
                Sign up
              </CtaButton>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

CouponsSubscribeForm.propTypes = {
  client: PropTypes.object.isRequired,
};

export default withApolloClient(CouponsSubscribeForm);
